<template>
  <div>
    <new-main-header v-if="hasNewLeftNavEnabled">
      Customer History
    </new-main-header>
    <main-header v-else>
      <span slot="arrow-back">
        <el-tooltip
            class="item"
            effect="dark"
            content="Back to Start Page"
            placement="bottom-start">
          <router-link :to="{ name: 'HomePage' }"><i class="el-icon-back" /> </router-link>
        </el-tooltip>
      </span>
      <span slot="page-title">Customer History</span>
    </main-header>
    <main-content>
      <el-menu
          v-if="false"
          slot="horizontal-menu"
          default-active="1"
          class="ring-menu--horizontal"
          mode="horizontal">
        <el-menu-item
            v-scroll-to="{
              el: '#history-app',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="1">
          {{ $t('history.app_activity') }}
        </el-menu-item>
        <el-menu-item
            v-scroll-to="{
              el: '#history-events',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="2">
          {{ $t('history.events') }}
        </el-menu-item>
        <el-menu-item
            v-scroll-to="{
              el: '#history-config',
              container: '#main-content',
              duration: 500,
              easing: 'linear'}"
            index="3">
          {{ $t('history.config') }}
        </el-menu-item>
      </el-menu>

      <div
          slot="main-content">
        <device-events id="history-events" />
        <customer-setups id="history-setups" />
        <device-history id="device-ownership" />
        <el-card id="customer-transfers">
          <div
              slot="header"
              class="clearfix">
            <span class="header-item">{{ $t('dos.title') }}</span>
          </div>
          <div class="card-content">
            <router-link
                id="customer-transfers-link"
                :to="{ name: 'CustomerTransfers', params: { customer_id: customerId } }">
              {{ $t('dos.view_transfers') }}
            </router-link>
          </div>
        </el-card>
        <user-activity id="user-activity" />
      </div>
    </main-content>
  </div>
</template>

<script>
import DeviceEvents from "./History/Events";
import CustomerSetups from "./History/Setups";
import DeviceHistory from "./History/DeviceOwnership";
import MainContent from "@/containers/Core/MainContent";
import MainHeader from "@/containers/Core/Header/MainHeader";
import UserActivity from "./History/UserActivity";
import NewMainHeader from "@/NewUI/containers/core/header/MainHeader";
import permission from "@/mixins/permission";

import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("db/account");
export default {
  name: "History",
  components: {
    MainContent,
    MainHeader,
    DeviceEvents,
    CustomerSetups,
    DeviceHistory,
    UserActivity,
    NewMainHeader,
  },
  mixins: [permission],
  data() {
    return {
      history: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["email", "customer", "customerId"]),
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
  },
  created() {
    this.loadHistory();
  },
  mounted() {
    setTimeout(() => this.scrollToHash("#"), 1000);
  },
  methods: {
    loadHistory() {
      console.log("load history information");
    },
    scrollToHash() {
      let section = this.$route.hash;
      if (section) {
        this.$nextTick(() => {
          this.$scrollTo(section, {
            duration: 500,
            container: "#main-content",
          });
        });
      }
    },
  },
};
</script>

<style lang="css"></style>
